<div class="modal-content-container" [class.monitor]="isMonitorMode">
  <div class="modal-header" *ngIf="!isMonitorMode">
    <div class="actions">
      <button nz-button nzType="default" (click)="clearAllFilters()" style="margin-right: 8px;">
        <i nz-icon nzType="clear"></i> Limpar Filtros
      </button>
      <button nz-button nzType="primary" (click)="exportToPdf()">
        <i nz-icon nzType="file-pdf"></i> Exportar PDF
      </button>
    </div>
  </div>

  <nz-spin [nzSpinning]="loading">
    <ng-container *ngIf="displayedChecklists.length > 0; else noData">
      <nz-table #basicTable [nzData]="displayedChecklists" [nzShowPagination]="false" [nzFrontPagination]="false"
        [nzScroll]="isMonitorMode ? { y: 'calc(100vh - 280px)' } : { y: '400px' }">
        <thead>
          <tr>
            <th nzWidth="80px" [nzCustomFilter]="!isMonitorMode">
              ID
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="idMenu">
                <i nz-icon nzType="search"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="150px" [nzCustomFilter]="!isMonitorMode">
              Modelo
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="modelMenu">
                <i nz-icon nzType="filter"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="150px" [nzCustomFilter]="!isMonitorMode">
              Chassis
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="chassisMenu">
                <i nz-icon nzType="filter"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="100px" [nzCustomFilter]="!isMonitorMode">
              Tipo
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="typeMenu">
                <i nz-icon nzType="filter"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="120px" [nzCustomFilter]="!isMonitorMode">
              Data
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="dateMenu">
                <i nz-icon nzType="filter"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="150px" [nzCustomFilter]="!isMonitorMode">
              Responsável
              <nz-filter-trigger *ngIf="!isMonitorMode" [nzDropdownMenu]="userMenu">
                <i nz-icon nzType="filter"></i>
              </nz-filter-trigger>
            </th>
            <th nzWidth="80px" *ngIf="!isMonitorMode">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of displayedChecklists">
            <td [class.monitor-td]="isMonitorMode">{{ data.id }}</td>
            <td [class.monitor-td]="isMonitorMode">{{ data.ProductModel.name }}</td>
            <td [class.monitor-td]="isMonitorMode" style="text-transform: uppercase;">{{ data.chassis }}</td>
            <td [class.monitor-td]="isMonitorMode">{{ getTypeLabel(data.type) }}</td>
            <td [class.monitor-td]="isMonitorMode">{{ data.date | date:'dd/MM/yyyy' }}</td>
            <td [class.monitor-td]="isMonitorMode">{{ data.UserModel.name }}</td>
            <td *ngIf="!isMonitorMode">
              <button nz-button nzType="primary" nzSize="small" (click)="navigateToDetails(data.id)">
                Ir
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div *ngIf="!isMonitorMode" style="margin-top: 16px; display: flex; justify-content: flex-end;">
        <nz-pagination [nzPageIndex]="currentPage" [nzPageSize]="currentPageSize" [nzTotal]="checklistHeaderTotal"
          (nzPageIndexChange)="onPageChange($event)" (nzPageSizeChange)="onPageSizeChange($event)" nzShowSizeChanger
          [nzPageSizeOptions]="[10, 20, 50, 100]">
        </nz-pagination>
      </div>
    </ng-container>

    <ng-template #noData>
      <div style="text-align: center; padding: 20px;">
        <i nz-icon nzType="inbox" style="font-size: 32px; color: #ccc;"></i>
        <p style="color: #999; margin-top: 8px;">Nenhum checklist encontrado com o status {{ cardName }}</p>
      </div>
    </ng-template>
  </nz-spin>
</div>

<!-- ID Filter Menu -->
<nz-dropdown-menu #idMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Buscar ID" [(ngModel)]="idSearch" (ngModelChange)="onIdSearch($event)" />
    </div>
  </div>
</nz-dropdown-menu>

<!-- Model Filter Menu -->
<nz-dropdown-menu #modelMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Buscar Modelo" [(ngModel)]="modelSearch"
        (ngModelChange)="onModelSearch($event)" />
    </div>
    <div class="filter-list">
      <label nz-checkbox *ngFor="let filter of visibleModelFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div class="filter-actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyModelFilter()">Filtrar</button>
      <button nz-button nzSize="small" (click)="clearModelFilter()">Limpar</button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Chassis Filter Menu -->
<nz-dropdown-menu #chassisMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Buscar Chassis" [(ngModel)]="chassisSearch"
        (ngModelChange)="onChassisSearch($event)" />
    </div>
    <div class="filter-list">
      <label nz-checkbox *ngFor="let filter of visibleChassisFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div class="filter-actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyChassisFilter()">Filtrar</button>
      <button nz-button nzSize="small" (click)="clearChassisFilter()">Limpar</button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Type Filter Menu -->
<nz-dropdown-menu #typeMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="filter-list">
      <label nz-checkbox *ngFor="let filter of visibleTypeFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div class="filter-actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyTypeFilter()">Filtrar</button>
      <button nz-button nzSize="small" (click)="clearTypeFilter()">Limpar</button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Date Filter Menu -->
<nz-dropdown-menu #dateMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px;">
      <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateSearch($event)"></nz-range-picker>
    </div>
  </div>
</nz-dropdown-menu>

<!-- User Filter Menu -->
<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input type="text" nz-input placeholder="Buscar Responsável" [(ngModel)]="userSearch"
        (ngModelChange)="onUserSearch($event)" />
    </div>
    <div class="filter-list">
      <label nz-checkbox *ngFor="let filter of visibleUserFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div class="filter-actions">
      <button nz-button nzSize="small" nzType="primary" (click)="applyUserFilter()">Filtrar</button>
      <button nz-button nzSize="small" (click)="clearUserFilter()">Limpar</button>
    </div>
  </div>
</nz-dropdown-menu>